<template>
  <el-select
    v-model="selectedCommunityId"
    :placeholder="placeholder"
    clearable
    @change="handleChange">
    <el-option
      v-for="item in communityList"
      :key="item.communityId"
      :label="item.name"
      :value="item.communityId">
    </el-option>
  </el-select>
</template>

<script>
import { listAdminCommunitys } from '@/api/owner/adminOwnerApi'

export default {
  name: 'SelectAdminCommunity',
  props: {
    placeholder: {
      type: String,
      default: '请选择小区'
    },
    communityId: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      communityList: [],
      selectedCommunityId: this.communityId || ''
    }
  },
  created() {
    this.loadCommunities()
  },
  watch: {
    communityId(val) {
      this.selectedCommunityId = val
    }
  },
  methods: {
    loadCommunities() {
      const params = {
        page: 1,
        row: 100
      }

      listAdminCommunitys(params).then(res => {
        this.communityList = [{ name: this.$t('adminOwner.all'), communityId: '' }, ...res.data]
      }).catch(error => {
        console.log(error)
        this.$message.error(this.$t('adminOwner.fetchCommunityError'))
      })
    },
    handleChange(communityId) {
      const community = this.communityList.find(c => c.communityId === communityId) || { communityId: '', name: '' }
      this.$emit('changeCommunity', community)
    }
  }
}
</script>
